const TmsDatalayer = require('../models/tms_datalayer.model').default;
const datalayer = new TmsDatalayer();

const thirdParties = {
    qualtrics(event) {
        import('@edreamsodigeo/frontend-tracking-agent').then(({thirdPartyTracking}) => {
            const thirdPartyTrackingAgent = thirdPartyTracking.createThirdPartyTrackingAgent({});
            thirdPartyTrackingAgent.trackQualtrics(event);
        });
    },
};

module.exports = {
    fireEvent: function(category, key, value) {
        datalayer.fireEvent(category, key, value);
    },

    fireExternalEvent: function(target, event) {
        const thirdParty = thirdParties[target];
        if (typeof thirdParty === 'function') {
            thirdParty(event);
        }
    },

    updateDatalayer: function(data) {
        datalayer.updateDatalayer(data);
    },

    updateAndExtendDatalayer(data, options) {
        datalayer.updateAndExtendDatalayer(data, options);
    },

    loadContainer() {
        datalayer.loadContainer();
    },

    sendEvent: function(event) {
        datalayer.sendTmsEvent(event);
    },

    observeTmsTotalPrice(elementId) {
        const observer = new MutationObserver((mutations, obs) => {
            const parentElement = elementId ? document.getElementById(elementId) : document;
            const priceElement = parentElement ? parentElement.getElementsByClassName('total_price_tms')[0] : false;
            if (priceElement && !Odigeo._.isEmpty(priceElement.dataset['priceTms'])) {
                setTimeout(() => {
                    const tmsTotalPrice = priceElement.dataset['priceTms'];
                    this.fireEvent('price_available', 'product_total_price_dom', tmsTotalPrice);
                    this.updateAndExtendDatalayer(tmsTotalPrice ? {priceInfo: {
                        product_total_price_dom: tmsTotalPrice,
                    }} : {});
                }, 2500);
                obs.disconnect();
            }
        });
        observer.observe(document, {childList: true, subtree: true});
    },
};
